import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

const HEADING_NODE_TYPE = 'heading';

export type HeadingSection = {
	endIndex: number;
	endPos: number;
	startIndex: number;
	startPos: number;
};

export const getHeadingSection = (doc: PMNode, headingPos: number): HeadingSection | null => {
	let currentPos = 0;
	for (let index = 0; index < doc.childCount; index++) {
		const child = doc.child(index);
		if (currentPos !== headingPos) {
			currentPos += child.nodeSize;
			continue;
		}

		if (child.type.name !== HEADING_NODE_TYPE) {
			return null;
		}

		let endPos = headingPos + child.nodeSize;
		let endIndex = index + 1;
		for (let sectionIndex = index + 1; sectionIndex < doc.childCount; sectionIndex++) {
			const sectionNode = doc.child(sectionIndex);
			if (sectionNode.type.name === HEADING_NODE_TYPE) {
				break;
			}
			endPos += sectionNode.nodeSize;
			endIndex = sectionIndex + 1;
		}

		return {
			startPos: headingPos,
			endPos,
			startIndex: index,
			endIndex,
		};
	}

	return null;
};
